<template>
  <div class="detail_box">
    <div class="detail_base">
      <div class="portrait">
        <div class="img">
          <img :src="dmInfo.memberResourceUrl" alt="" :onerror="imgLoadError(dmInfo)" />
        </div>
        <img :class="'pos pos'+dmInfo.identityInfo.topLeftResourceId" :src="dmInfo.identityInfo.bottomResourceUrl" alt="" v-if="!!dmInfo.identityInfo && JSON.stringify(dmInfo.identityInfo) != '{}'">
      </div>
      <div class="text">
        <span class="name" v-text="dmInfo.memberNickname"></span>
        <span class="time" v-text="dmInfo.publishTime"></span>
      </div>
    </div>
    <div class="location" v-if="dmInfo.address.length > 0">
      <Icon iconClass="locate" /><span v-text="dmInfo.address"></span>
    </div>
    <div class="detail_desc" v-html="dmInfo.description" v-if="dmInfo.description.length > 0"></div>
    <div class="detail_video" v-if="dmInfo.streamInfo.hasOwnProperty('streamPlayUrl')">
      <div class="player">
        <video :src="dmInfo.streamInfo.streamPlayUrl" :poster="dmInfo.streamInfo.samplePicUrl" :width="dmInfo.streamInfo.videoWidth" :height="dmInfo.streamInfo.videoHeight" controls controlslist="nodownload" disablepictureinpicture></video>
      </div>
    </div>
    <div class="detail_imgs" v-if="dmInfo.pictureUrlList.length > 0">
      <div class="img_item" v-for="(src, index) in dmInfo.pictureUrlList" :key="index">
        <img :src="src" alt="" v-if="!!src" />
        <img src="@/assets/images/default_pic_16_9.png" alt="" v-else />
      </div>
    </div>
    <div class="report_reply_box" v-if="dmInfo.status!=0 && dmInfo.replyContent.length>0">
      <div v-text="'审核回复：'"></div>
      <div v-text="dmInfo.replyContent"></div>
    </div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
export default {
  name: "Detail",
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dmInfo: null,
    };
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.dmInfo = deepClone(newValue);
      },
      deep: true,
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
  },
  created() {
    this.dmInfo = deepClone(this.detail);
  },
};
</script>
<style scoped lang="scss">
.detail_box {
  padding-bottom: 40px;
  .detail_base {
    display: flex;
    line-height: 30px;
    .portrait {
      position: relative;
      width: 32px;
      height: 32px;
      margin-right: 10px;
      .img {
        width: 100%;
        height: 100%;
        line-height: 32px;
        overflow: hidden;
        background-image: url(~@/assets/images/user_default.png);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        justify-content: center;
        border-radius: 50%;
        img {
          -o-object-fit: cover;
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
      .pos {
        position: absolute;
        &.pos1 {
          left: -4px;
          top: -4px;
          width: 16px;
          height: 16px;
        }
        &.pos2 {
          right: -4px;
          top: -4px;
          width: 16px;
          height: 16px;
        }
        &.pos3 {
          left: -4px;
          bottom: -4px;
          width: 16px;
          height: 16px;
        }
        &.pos4 {
          left: 50%;
          bottom: -8px;
          width: auto;
          height: 16px;
          transform: translateX(-50%);
        }
        &.pos5 {
          right: -4px;
          bottom: -4px;
          width: 16px;
          height: 16px;
        }
      }
    }
    .text {
      position: relative;
      width: 100%;
      overflow: hidden;
      flex: 1;
      .name {
        color: #1a1a1a;
        font-size: 14px;
      }
      .time {
        float: right;
        color: #646464;
        font-size: 12px;
      }
    }
  }
  .location {
    margin-top: 5px;
    line-height: 24px;
    .tj-svg-icon {
      color: #a6a6a6;
      margin-right: 5px;
      font-size: 14px;
    }
    span {
      color: #666;
      font-size: 14px;
    }
  }
  .detail_desc {
    margin: 10px auto;
    line-height: 24px;
    color: #323232;
    text-align: justify;
    font-size: 16px;
  }
  .detail_video {
    .player {
      video {
        display: block;
        max-width: 100%;
        height: auto;
        // 隐藏video 音量按钮
        &::-webkit-media-controls-mute-button {
          display: none;
        }
        // 隐藏video 全屏按钮
        &::-webkit-media-controls-fullscreen-button {
          display: none;
        }
      }
    }
  }
  .detail_imgs {
    .img_item {
      padding-top: 8px;
      padding-bottom: 8px;
      text-align: center;
      img {
        display: block;
        max-width: 100%;
        margin: auto;
      }
    }
  }
  .report_reply_box {
    margin-top: 5px;
    line-height: 24px;
    color: #d70c2a;
    font-size: 16px;
  }
}
</style>